// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1MKrI","errorLogs":"EditorFooter_errorLogs__2stqS"};